<template>
  <v-row class="text-end">
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn color="#D1433F" v-bind="attrs" v-on="on" text>View</v-btn>
      </template>
      <v-card>
        <v-toolbar flat color="white">
          <v-btn icon @click="dialog = false">
            <v-icon color="#d11724">mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ title }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-progress-circular
            v-if="uploading"
            indeterminate
          ></v-progress-circular>

          <v-btn
            v-if="uploading === false && getArea"
            color="primary mt-1"
            medium
            absolute
            right
            fab
            @click="onPickFile"
          >
            <v-icon medium>mdi-plus</v-icon>
          </v-btn>
          <input
            type="file"
            style="display: none"
            ref="fileInput"
            accept="image/*"
            multiple="multiple"
            @change="onFilePicked"
          />
        </v-toolbar>
        <vueSilentbox :gallery="gallery"></vueSilentbox>
        <v-row v-if="getArea">
          <v-col cols="12" sm="6">
            <v-container fluid>
              <v-row>
                <v-col
                  v-for="(image, key) in gallery"
                  :key="key"
                  class="d-flex child-flex"
                  cols="4"
                >
                  <v-card flat tile class="d-flex">
                    <vueSilentbox :image="image">
                      <v-btn
                        v-if="uploading === false"
                        color="error"
                        medium
                        absolute
                        right
                        fab
                        @click="deleteImage(image)"
                      >
                        <v-icon medium>mdi-delete</v-icon>
                      </v-btn>
                    </vueSilentbox>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import vueSilentbox from "vue-silentbox/src/components/gallery";

export default {
  props: {
    myData: {
      type: Object,
      required: false
    },
    title: {
      type: String,
      required: true
    }
  },
  components: {
    vueSilentbox
  },
  computed: {
    ...mapGetters("global", ["getArea"]),
    gallery: function() {
      var returnVals = [];
      const id = this.myData.Id;
      this.myData.PhotoEntities.map(function(x) {
        returnVals.push({
          src: x.Image_Link,
          thumbnailWidth: "220px",
          id: x.Id,
          albumId: id
        });
      });
      return returnVals;
    },
    gallery2: function() {
      var returnVals = [];
      this.myData.PhotoEntities.map(function(x) {
        returnVals.push(x.Image_Link);
      });
      return returnVals;
    }
  },
  data() {
    return {
      uploading: false,
      uploadingProgress: 20,
      dialog: false,
      notifications: false,
      sound: true,
      widgets: false
    };
  },
  methods: {
    ...mapActions("gallery", ["postPhoto", "deletePhoto"]),
    onPickFile() {
      this.$refs.fileInput.click();
    },
    async onFilePicked(event) {
      try {
        this.uploading = true;
        await this.postPhoto({
          files: event.target.files,
          albumId: this.myData.Id
        });
        this.uploading = false;
      } catch (error) {
        console.log(error);
        this.uploading = false;
      }
    },
    async deleteImage(data) {
      try {
        await this.deletePhoto(data.id);
      } catch (error) {
        console.log(error);
      }
    }
  },
  created() {}
};
</script>